/**
 * WordPress dependencies
 */
import { addQueryArgs } from '@safe-wordpress/url';
import type {
	dispatch as Dispatch,
	select as Select,
} from '@safe-wordpress/data';

/* eslint-disable */
const parent = window.parent as any;
const dispatch = parent.wp.data.dispatch as typeof Dispatch;
const select = parent.wp.data.select as typeof Select;
/* eslint-enable */

// NOTE. No @nab packages in front.
import type { store as dataStore } from '@nab/data';
const NAB_DATA = 'nab/data' as unknown as typeof dataStore;

export function isExternalLink( link: string ): boolean {
	// Internal link.
	if ( ! /^[a-z]+:\/\//.test( link ) ) {
		return false;
	}

	link = link.replace( /^https?:\/\//, 'http://' );
	const currentDomain = document.location.href
		.replace( /^https?:\/\//, '' )
		.replace( /\/.*$/, '' );
	if ( 0 === link.indexOf( 'http://' + currentDomain ) ) {
		return false;
	}

	return true;
}

export function disableExternalLinks(): void {
	Array.from( document.querySelectorAll< HTMLAnchorElement >( 'a' ) ).forEach(
		( link ) => {
			const href = link.getAttribute( 'href' ) || '';
			if ( ! isExternalLink( href ) ) {
				return;
			}

			link.classList.add( 'nab-disabled-link' );
			link.addEventListener( 'click', ( ev ) => ev.preventDefault() );
		}
	);
}

export function addParamToLocalLinks(
	paramName: string,
	paramValue = true
): void {
	Array.from( document.querySelectorAll< HTMLAnchorElement >( 'a' ) ).forEach(
		( link ) => {
			const href = link.getAttribute( 'href' ) || '';
			if ( isExternalLink( href ) ) {
				return;
			}

			// HACK. Remove fragment stuff when this pull request is finally merged: https://github.com/WordPress/gutenberg/pull/16656
			const cleanUrl = href.replace( /#.*$/, '' );
			const fragment = href.replace( /^[^#]*/, '' );
			const finalUrl =
				addQueryArgs( cleanUrl, { [ paramName ]: paramValue } ) +
				fragment;

			link.setAttribute( 'href', finalUrl );
		}
	);
}

export function markTestPreviewAsActive( active: boolean ): void {
	const editor = select( NAB_DATA ).getPageAttribute(
		'javascript-editor/javascriptEditorState'
	);
	if ( ! editor ) {
		return;
	}

	void dispatch( NAB_DATA ).setPageAttribute(
		'javascript-editor/javascriptEditorState',
		{
			...editor,
			isPreviewInScope: active,
		}
	);
}
